import { render, staticRenderFns } from "./ShareProposalModal.vue?vue&type=template&id=ba9e7cc0"
import script from "./ShareProposalModal.vue?vue&type=script&lang=js"
export * from "./ShareProposalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports